<template>
  <div>
    <el-form :model="basicData" ref="basicData" label-width="100px">
      <div class="topFrom" ref="sub">
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('purchaseReturn.form.returnNo')">
              <el-input v-model="basicData.returnNo" :disabled="true"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="isReturn" :label="$t('purchaseReturn.form.isReturn')">
              <el-select
                style="width: 100%"
                v-model="basicData.isReturn"
                :disabled="true"
                @change="changeMethord"
                filterable
                placeholder=""
              >
                <el-option
                  v-for="item in isReturnList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="basicData.isReturn == 0">
            <el-form-item prop="returnMethod" :label="$t('purchaseReturn.form.exchangeMethod')">
              <el-select
                style="width: 100%"
                v-model="basicData.returnMethod"
                :disabled="canNotEdit"
                filterable
                placeholder=""
              >
                <el-option
                  v-for="item in returnMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="basicData.isReturn == 1">
            <el-form-item prop="returnMethod" :label="$t('purchaseReturn.form.returnMethod')">
              <el-select
                style="width: 100%"
                v-model="basicData.returnMethod"
                :disabled="canNotEdit"
                filterable
                placeholder=""
              >
                <el-option
                  v-for="item in returnMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="estimatedOutboundTime"
              :label="$t('purchaseReturn.form.estimatedOutboundTime')"
            >
              <el-date-picker
                style="width: 100%"
                v-model="basicData.estimatedOutboundTime"
                :disabled="canNotEdit"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                :picker-options="pickerStartOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="returnCompanyCode" :label="$t('purchaseReturn.form.companyName')">
              <el-select
                style="width: 100%"
                v-model="basicData.returnCompanyCode"
                :disabled="canNotEdit"
                filterable
                placeholder=""
                @change="changeCompany"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="returnDepartmentCode"
              :label="$t('purchaseReturn.form.departmentName')"
            >
              <el-select
                style="width: 100%"
                v-model="basicData.returnDepartmentCode"
                :disabled="canNotEdit"
                filterable
                placeholder=""
              >
                <el-option
                  v-for="item in businessDepartmentList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="returnOperatorName"
              :label="$t('purchaseReturn.form.returnOperatorNo')"
            >
              <el-input v-model="basicData.returnOperatorName" :disabled="true"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="returnSalesmanNo"
              :label="$t('purchaseReturn.form.returnSalesmanNo')"
            >
              <el-input
                v-model="basicData.returnSalesmanName"
                v-if="canNotEdit == true"
                :disabled="true"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="partnerCode" :label="$t('purchaseReturn.form.partnerCode')">
              <el-input v-model="basicData.partnerName" v-if="canNotEdit == true" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="outboundStorageCode"
              :label="$t('purchaseReturn.form.outboundStorageCode')"
            >
              <el-input
                v-model="basicData.outboundStorageName"
                v-if="canNotEdit == true"
                :disabled="true"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="freightTaker" :label="$t('purchaseReturn.form.freightTaker')">
              <el-select
                style="width: 100%"
                v-model="basicData.freightTaker"
                :disabled="canNotEdit"
                filterable
                placeholder=""
              >
                <el-option
                  v-for="item in freightTakerTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="freightAmount" :label="$t('purchaseReturn.form.freightAmount')">
              <input-number
                style="width: 100%"
                :disabled="canNotEdit"
                placeholder=" "
                v-model="basicData.freightAmount"
                max="99999999999.999999"
                :precision="6"
                @input="(val) => handleChangeNumber(val)"
              ></input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="basicData.isReturn == 1">
          <el-col :span="6">
            <el-form-item :label="$t('purchaseReturn.form.isReturnMoney')">
              <el-checkbox
                @change="changeIsReturnMoney"
                v-model="basicData.isReturnMoney"
                :disabled="canNotEdit"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="basicData.isReturnMoney">
            <el-form-item
              prop="returnMoneyMethod"
              :label="$t('purchaseReturn.form.returnMoneyMethod')"
            >
              <el-select
                style="width: 100%"
                v-model="basicData.returnMoneyMethod"
                :disabled="canNotEdit"
                filterable
                placeholder=""
              >
                <el-option
                  v-for="item in returnMoneyMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="supplierStorageCode"
              :label="$t('purchaseReturn.form.supplierStorageCode')"
            >
              <el-input
                v-model="basicData.supplierStorageName"
                v-if="canNotEdit == true"
                :disabled="true"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div>
        <!-- <ReturnDetail v-if="canNotEdit == true && basicData.isReturn==0 "
      v-bind:tableData="basicData.tableData" 
      v-bind:isReturn="basicData.isReturn"
      ref="returnDetail"/> -->
        <ExchangeDetail
          v-if="canNotEdit == true && basicData.isReturn == 1"
          v-bind:tableData="basicData.tableData"
          v-bind:isReturn="basicData.isReturn"
          ref="exchangeDetail"
        />
      </div>
      <div class="gird padding-bottom">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('purchaseReturn.form.mark')" label-width="80px">
              <el-input
                v-model="basicData.returnMark"
                :disabled="canNotEdit"
                type="textarea"
                :rows="3"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021042915443816012']"
        v-if="canNotEdit == false && basicData.returnStatus != 'ZT05'"
        type="primary"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915450308182']"
        v-if="canNotEdit == false"
        type="primary"
        @click="commit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.commit') }}</el-button
      >
      <el-button
        v-if="
          canNotEdit == true &&
          (basicData.returnStatus == 'ZT06' || basicData.returnStatus == 'ZT05')
        "
        type="primary"
        @click="gotoEdit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.edit') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915435544045']"
        v-if="canNotEdit == true && basicData.returnStatus == 'ZT06'"
        type="primary"
        @click="del"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <!-- <el-button v-if="canNotEdit == true " type="primary" @click="print" :loading="load" class="fixed-bottom-btn">{{$t('functionBtn.print')}}</el-button> -->
      <el-button
        v-if="canNotEdit == true && basicData.returnStatus == 'ZT07'"
        type="primary"
        @click="copy"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.copy') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915453445344']"
        v-if="canNotEdit == true && basicData.returnStatus == 'ZT07'"
        type="primary"
        @click="doConfirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.confirm') }}</el-button
      >
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  // import SearchModal from '@/components/SearchModal';
  // import Exchange from './component/exchange';
  // import Return from './component/return';
  // import ReturnDetail from './component/returnDetail';
  import ExchangeDetail from './component/exchangeDetail';
  import API from '@/api/purchaseSalesCenter/purchaseReturn.js';
  import DataBaseAPI from '@/api/dataBase';
  import rules from './rules/rules';
  import masterObj from '@/common/js/masterObj';
  import inputNumber from '@/components/form-item/input-number';

  export default {
    name: 'purchaseReturnAdd',
    components: {
      // SearchModal,
      // Exchange,
      // Return,
      // ReturnDetail,
      ExchangeDetail,
      inputNumber,
    },
    data() {
      return {
        canNotEdit: true,
        load: false,
        partnerType: '123',
        rules: rules.rules,
        isShow: 0,
        companyList: [], //公司列表
        businessDepartmentList: [], //事业部门列表
        returnMethodList: [], //退换货方式
        currencyTypeList: [], //币种
        isReturnList: [
          { value: 0, label: '换货' },
          { value: 1, label: '退货' },
        ], //性质
        freightTakerTypeList: [], //运费承担
        returnMoneyMethodList: [], //退款方式
        businessInboundNoList: [], //业务入库单号
        businessInboundBatchNoList: [], //业务入库批次
        tableToolbar: {
          id: 'toolbar',
        },
        pickerStartOptions: {
          disabledDate: (time) => {
            let startDate = new Date();
            if (startDate) {
              return time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000;
            }
          },
        },
        tableData: [{}],
        basicData: {
          isReturn: 1,
          isReturnMoney: false,
          returnDepartmentName: '',
          returnDepartmentCode: '',
          returnCompanyName: '',
          returnCompanyCode: '',
        },
        warehouse: masterObj.warehouse,
        partner: masterObj.partner,
        goods: masterObj.goodsDetail,
        person: masterObj.person,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    created() {
      this.getData();
    },
    /**页面必要代码Start */
    mounted() {
      if (!this.$route.query.returnNo) {
        this.basicData.returnOperatorName = this.userInfo.userInfo.userName;
        this.basicData.returnOperatorNo = this.userInfo.userInfo.userCode;
        this.basicData.returnSalesmanName = this.userInfo.userInfo.userName;
        this.basicData.returnSalesmanNo = this.userInfo.userInfo.userCode;
        this.basicData.returnCompanyCode = this.userInfo.userInfo.companyCode;
        this.basicData.returnDepartmentCode = this.userInfo.userInfo.departmentCode;
        this.getCompany();
        // this.basicData.returnCompanyName = this.userInfo.userInfo.companyName
        // this.basicData.returnDepartmentName = this.userInfo.userInfo.departmentName
      }
      this.warehouse.query.adminFlag = this.userInfo.userInfo.adminFlag;
      this.getDic();
    },
    methods: {
      //业务部门
      initDepartment() {
        this.$axios
          .post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + this.basicData.returnCompanyCode)
          .then((res) => {
            if (0 == res.data.code) {
              this.businessDepartmentList = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
          if (this.basicData.returnCompanyCode) {
            this.initDepartment();
          }
        }
      },
      //获取字典值
      getDic() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 合作伙伴类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'partner_type', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.partnerTypeList = res.data.data; // 下拉
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        //运费承担
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'freight_taker', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.freightTakerTypeList = res.data.data;
            }
          });
        //退换货方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'return_method', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.returnMethodList = res.data.data;
            }
          });
        //退款方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'pay_method', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.returnMoneyMethodList = res.data.data;
            }
          });
        //单据状态
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'purchase_return_status', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.requestStatusList = res.data.data;
            }
          });
      },
      //选择合作伙伴
      setPartner(val, row) {
        if (row.length > 0) {
          this.basicData.partnerCode = row[0].partnerCode;
          this.basicData.partnerName = row[0].partnerZhName;
        }
      },
      //选择仓库(出库)
      setWareHouseOut(val, row) {
        if (row.length > 0) {
          this.basicData.outboundStorageCode = row[0].storageCode;
          this.basicData.outboundStorageName = row[0].storageName;
          this.warehouse.query.warehouseNo = row[0].storageCode;
        }
      },
      //选中业务员
      setSalesman(val, row) {
        if (row.length > 0) {
          this.basicData.returnSalesmanNo = row[0].returnSalesmanNo;
          this.basicData.returnSalesmanName = row[0].returnSalesmanName;
        }
      },
      //选中仓库(供应商)
      setWarehouseIn(val, row) {
        if (row.length > 0) {
          this.basicData.supplierStorageCode = row[0].storageCode;
          this.basicData.supplierStorageName = row[0].storageName;
        }
      },
      //切换公司
      changeCompany(val) {
        //locations是v-for里面的也是datas里面的值
        // let obj = {};
        let value = this.companyList.find((item) => item.value === val);
        this.basicData.returnDepartmentCode = '';
        this.businessDepartmentList = [];
        if (value) {
          this.initDepartment();
        }
      },
      //修改性质
      changeMethord(val) {
        let _self = this;
        setTimeout(function () {
          let tableData = [{ exchangeRate: '1.12' }];
          if (val == 0) {
            _self.$refs.returnTable.setVal(tableData);
          } else {
            _self.$refs.exchangeTable.setVal(tableData);
          }
        }, 1000);
      },
      //修改运费金额
      handleChangeNumber(val) {
        this.basicData.freightAmount = val;
      },
      getData() {
        //控制页面是否可修改
        if (this.$route.query && this.$route.query.canEdit && this.$route.query.canEdit == '0') {
          this.canNotEdit = true;
        } else {
          this.canNotEdit = false;
        }
        let _self = this;
        if (this.$route.query && this.$route.query.returnNo) {
          //如果是修改页面，先查询需要修改数据的详情
          this.$axios
            .get(API.UPDATE_PURCHASE_RETURN_API + '/' + this.$route.query.returnNo)
            .then((res) => {
              if (res.data.code === 0) {
                this.basicData = res.data.data;
                if (this.$route.query && this.$route.query.copy && this.$route.query.copy == '0') {
                  this.basicData.returnNo = null;
                  this.basicData.id = null;
                  this.basicData.version = null;
                }
                if (this.basicData.isReturnMoney == 0) {
                  this.basicData.isReturnMoney = false;
                } else {
                  this.basicData.isReturnMoney = true;
                }
                this.tableData = this.basicData.purchaseReturnDetailList;
                if (this.canNotEdit === true) {
                  _self.$refs.exchangeDetail.setVal(res.data.data.purchaseReturnDetailList);
                  // setTimeout(function(){
                  //   if(_self.basicData.isReturn == 0 ){
                  //     _self.$refs.returnDetail.setVal(res.data.data.purchaseReturnDetailList)
                  //   }else{
                  //     _self.$refs.exchangeDetail.setVal(res.data.data.purchaseReturnDetailList)
                  //   }
                  // },1000)
                } else {
                  _self.$refs.exchangeTable.setVal(_self.tableData);
                  // setTimeout(function(){
                  //   if(_self.basicData.isReturn == 0 ){
                  //     _self.$refs.returnTable.setVal(_self.tableData)
                  //   }else{
                  //     _self.$refs.exchangeTable.setVal(_self.tableData)
                  //   }
                  // },1000)
                }
                this.getCompany();
              }
            });
        } else {
          setTimeout(function () {
            let tableData = [{ exchangeRate: '1.12' }];
            if (_self.basicData.isReturn == 0) {
              _self.$refs.returnTable.setVal(tableData);
            } else {
              _self.$refs.exchangeTable.setVal(tableData);
            }
          }, 1000);
        }
      },
      //修改是否退款
      changeIsReturnMoney(val) {
        this.$refs.exchangeTable.setReturnAmountEdit(val);
        //this.$refs.exchangeTable.setVal(this.tableData)
      },
      //更新表格数据
      updateTableData(data) {
        this.tableData = data;
      },
      //提交
      commit() {
        this.$refs.basicData.validate((valid) => {
          if (valid) {
            //校验表格
            let tableName = 'exchangeTable';
            if (this.basicData.isReturn === 0) {
              tableName = 'returnTable';
            }
            Promise.resolve(this.$refs[tableName].tableValid()).then((res) => {
              if (res) {
                this.saveData(1);
              }
            });
          }
        });
      },
      //保存
      save() {
        this.saveData(0);
      },
      saveData(type) {
        let data = this.basicData;
        data.type = type;
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        this.companyList.find((item) => {
          if (item.value === this.basicData.returnCompanyCode) {
            this.basicData.returnCompanyName = item.label;
          }
        });
        this.businessDepartmentList.map((item) => {
          if (item.value == this.basicData.returnDepartmentCode) {
            this.basicData.returnDepartmentName = item.label;
          }
        });
        data.purchaseReturnDetailListStr = JSON.stringify(this.tableData);
        if (data.isReturnMoney) {
          data.isReturnMoney = 1;
        } else {
          data.isReturnMoney = 0;
        }
        this.$axios.post(API.ADD_PURCHASE_RETURN_API, data).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.gotoList('purchaseReturnAdd');
          } else {
            if (type == 1 && res.data.data && res.data.data.id) {
              this.gotoList('purchaseReturnAdd');
            }
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //跳转到列表页面
      gotoList(name) {
        let path = {
          fromPath: {
            path: '/purchase/' + name,
            name: name,
            meta: {
              keepAlive: true,
              title: '采购退换货',
            },
          },
          toPath: {
            path: '/purchase/purchaseReturnList',
            name: 'purchaseReturnList',
            meta: {
              keepAlive: false,
              title: '采购退换货列表',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //删除
      del() {
        this.$confirmAction()
          .then(() => {
            let ids = [];
            ids.push(this.basicData.id);
            let returnNos = [];
            returnNos.push(this.basicData.returnNo);
            this.$axios.post(API.DELETE_PURCHASE_RETURN_API, { returnNos, ids }).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.gotoList('purchaseReturnDetail');
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //编辑
      gotoEdit() {
        let path = {
          path: '/purchase/purchaseReturnEdit',
          name: 'purchaseReturnEdit',
          meta: {
            keepAlive: true,
          },
          query: { returnNo: this.basicData.returnNo },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //复制
      copy() {
        let path = {
          path: '/purchase/purchaseReturnCopy',
          name: 'purchaseReturnCopy',
          meta: {
            keepAlive: true,
          },
          query: { returnNo: this.basicData.returnNo, copy: '0' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //生成物流运输单
      saveTransport() {
        //换货可能存在多个入库仓库，不同的入库仓库需要生成不同的物流运输单
        if (this.basicData.isReturn == 0) {
          let warehoseList = [];
          let warehouseData = {};
          if (this.tableData && this.tableData.length > 0) {
            this.tableData.map((item) => {
              if (warehouseData[item.inboundStorageNo]) {
                warehouseData[item.inboundStorageNo].data.push(item);
              } else {
                warehouseData[item.inboundStorageNo] = [];
                warehouseData[item.inboundStorageNo].push(item);
                warehoseList.push(item.inboundStorageNo);
              }
            });
          }
          for (let i = 0; i < warehoseList.length; i++) {
            this.saveDelivery(
              warehouseData[warehoseList[i]],
              warehoseList[i],
              warehouseData[warehoseList[i]][0].inboundStorageName
            );
          }
        } else {
          this.saveDelivery(
            this.tableData,
            this.basicData.supplierStorageCode,
            this.basicData.supplierStorageName
          );
        }
      },
      //保存物流运输单
      saveDelivery(deliveryDetailStr, warehouseCode, warehouseName) {
        let data = {};
        let tableData = JSON.parse(JSON.stringify(deliveryDetailStr));
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        data.deliveryCreatePersonName = this.basicData.returnOperatorName;
        data.deliveryCreatePersonNo = this.basicData.returnOperatorNo;
        data.deliveryLoginCompany = this.userInfo.userInfo.companyName;
        data.deliveryType = '4';
        data.otherNo = this.basicData.returnNo;
        data.providerNo = this.basicData.partnerCode;
        data.providerName = this.basicData.partnerName;
        data.salesmanNo = this.basicData.returnSalesmanNo;
        data.salesmanName = this.basicData.returnSalesmanName;
        data.deliveryDepartment = this.userInfo.userInfo.departmentName;
        data.pickupStorageNo = this.basicData.outboundStorageCode;
        data.pickupStorageName = this.basicData.outboundStorageName;
        data.shiptoStorageName = warehouseName;
        data.deliveryStatus = 1;
        let productList = [];
        tableData.map((item, index) => {
          let obj = {
            other_no: index + 1,
            providerNo: this.basicData.partnerCode,
            providerName: this.basicData.partnerName,
            productNo: item.productCode,
            productName: item.productName,
            deliveryQuantity: item.returnQuantity,
            contractUnit: item.productUnit,
            contractUnitName: item.productUnitName,
          };
          productList.push(obj);
        });
        data.deliveryDetailStr = JSON.stringify(productList);
        this.$axios.post(API.SAVE_DELIVERY, data).then((res) => {
          if (0 == res.data.code) {
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
          } else {
            //如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
      //打印
      print() {
        this.$message({
          type: 'error',
          message: '该功能暂未开放',
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .topFrom {
    padding: 26px 20px 8px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
  }
  .gird {
    margin-top: 10px;
    padding: 12px 20px 20px 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
  }
  .padding-bottom {
    padding-bottom: 80px;
  }
</style>
